// src/pages/Login.jsx
import React from 'react';
import { useSEO } from '../../hooks/useSEO';
import Layout from '../../components/Layout';
import LoginModal from '../../components/auth/LoginModal';
import { LOGIN_ROUTE } from '../../routes/constant';

const Login = () => {
  // Use SEO hook - only pass route, let SEO manager handle the data
  useSEO(LOGIN_ROUTE);

  return (
    <Layout>
      <LoginModal isPage={true} />
    </Layout>
  );
};

export default Login;